import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Button,
  Typography,
  Box,
  Avatar,
  FormLabel,
  FormControl,
  Skeleton,
  Popover,
} from "@mui/material";
import CloseIcon from "../assets/images/closeIcon.png";
import Select from "react-select";
import editProfileIcon from "../assets/images/editprofile.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  CreateStake,
  GetStakeDetail,
  UpdateStake,
} from "../service/StakeService";
import DefaultMan from "../assets/images/DefaultMan.png";
import DefaultWoman from "../assets/images/Defaultwoman.png";
import DefaultProfile from "../assets/images/DefaultProfile.png";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import { GetColourList } from "../service/ColourService";
import { AlertType } from "../shared/AlertType";
import { PreferencesContext } from "../PreferenceContext";
import { useNavigate, useParams } from "react-router-dom";
import { Controller, FormProvider, useForm } from "react-hook-form";
import * as Yup from "yup";
import { CreateStakemap, UpdateStakemap } from "../service/StakemapService";
import { GetTempTypeList } from "../service/TemperatureTypeService";
import { yupResolver } from "@hookform/resolvers/yup";
import { CreateNote } from "../service/NotesService";
import { BASE_URL } from "../service/common/const";
import { UploadProfile } from "../service/UploadProfile";
import AddNoteDialog from "./AddNotes";
import UploadProfileEdit from "../assets/images/uploadprofile.png";
import { Context } from "../service/models/Context";
import AddIcon from "@mui/icons-material/Add";
import { SketchPicker } from "react-color";
import nodeIcon from "../assets/images/nodeIcon.png";
interface AddStakeHolderDialogProps {
  open: boolean;
  UID: number;
  // onClose: (CODE?: string) => void;
  onClose: (CODE?: string, UID?: number) => void;
  title?: string;
}
const AddStakeHolderDialog: React.FC<AddStakeHolderDialogProps> = ({
  open,
  UID,
  onClose,
  title,
}) => {
  interface IStackHolder {
    UID: number;
    firstName: string;
    lastName: string;
    company: string;
    role: string;
    teamName: string;
    contact: string;
    temperature: string;
    temperatureColourCode: string | null;
    notes: string;
    nodecolour: string;
    profileImage: string;
  }

  let initStackHolder: IStackHolder = {
    UID: 0,
    firstName: "",
    lastName: "",
    company: "",
    role: "",
    teamName: "",
    contact: "",
    temperature: "",
    temperatureColourCode: null,
    notes: "",
    nodecolour: "",
    profileImage: "",
  };

  const navigate = useNavigate();
  // const { token } = useParams();
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  // const token = userContext?.token;
  const { token: tokenFromParams } = useParams();
  const token = tokenFromParams || userContext?.token;
  const handleClose = () => onClose();
  const defaultImages = [DefaultMan, DefaultWoman, DefaultProfile];
  const [selectedImage, setSelectedImage] = useState<string>(DefaultProfile);
  const [imageLocked, setImageLocked] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [colorOptions, setColorOptions] = useState<string[]>([]);
  const [selectedColor, setSelectedColor] = useState<string>("");
  const [temperatureTypeColl, setTemperatureTypeColl] = useState<any[]>([]);
  const [selectedImageFile, setSelectedImageFile] = useState<File | null>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const handleCustomColorClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  // close picker
  const handleClosePicker = () => {
    setAnchorEl(null);
  };
  const openColorPicker = Boolean(anchorEl);
  const StakeholderSchema = Yup.object().shape({
    UID: Yup.number().nullable(),
    firstName: Yup.string()
      .required("First name is required")
      .max(90, "First name must be at most 90 characters"),
    lastName: Yup.string()
      .nullable()
      .max(90, "lastName must be at most 90 characters"),
    company: Yup.string()
      .required("Company is required")
      .max(90, "Company Name must be at most 90 characters"),
    role: Yup.string().nullable().max(90, "Role must be at most 90 characters"),
    teamName: Yup.string()
      .nullable()
      .max(90, "Team/Department must be at most 90 characters"),
    contact: Yup.string()
      .nullable()
      .max(500, "Contact Detail must be at most 500 characters"),
    temperature: Yup.string().nullable(),
    temperatureColourCode: Yup.string().nullable(),
    notes: Yup.string()
      .nullable()
      .max(5000, "Notes must be at most 5000 characters"),
    nodecolour: Yup.string().when("UID", {
      is: (uid: number) => uid > 0,
      then: (schema) => schema.required("Node colour is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    profileImage: Yup.string().nullable(),
  });
  const methods = useForm({
    resolver: yupResolver(StakeholderSchema),
    defaultValues: initStackHolder,
  });
  // Handle file upload
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result as string);
      };
      reader.readAsDataURL(file);
      setSelectedImageFile(file);
      if (UID) {
        uploadProfileImage(file, UID,"");
      }
    }
  };
  const handleImageSelect = async (img: string) => {
    setSelectedImage(img);

    const blob = await fetch(img).then((res) => res.blob());

    const file = new File([blob], `default-${Date.now()}.jpg`, {
      type: blob.type,
    });
    setSelectedImageFile(file);
    if (UID) {
      uploadProfileImage(file, UID,"");
    }
  };

  const uploadProfileImage = async (
    file: File,
    uid: string | number,
    code: string
  ) => {
    const formData = new FormData();
    formData.append("profile", file);
    formData.append("uid", uid.toString());
    try {
      const response = await UploadProfile(formData);
      // if (response?.data?.filePath) {
      //   setSelectedImage(`${BASE_URL}${response.data.response.data.base64}`);
      //   const finalUrl = `${BASE_URL}${response.data.response.data.base64}`;
      //   methods.setValue("profileImage", finalUrl, { shouldValidate: true });
      //   // if (UID > 0) {
      //   //   getStakeDetail(UID);
      //   // }
      // }
      if (code === "CREATE") {
        getStakeDetail(UID);
      }
    } catch (error) {
      console.error("Upload error:", error);
    } finally {
    }
  };

  const [showMoreDetails, setShowMoreDetails] = useState(false);

  const handleToggleMoreDetails = () => {
    setShowMoreDetails(!showMoreDetails);
  };
  const [addNotesPopup, setAddNotesPopup] = useState<any>({
    open: false,
    UID: null,
  });
  const closeNotesPopup = async (code?: string) => {
    if (code === "SUBMIT") {
      await getStakeDetail(UID);
    }
    setAddNotesPopup({ open: false, stakeId: null });
  };
  const openNotesPopup = (UID: any) => {
    setAddNotesPopup({ open: true, UID });
  };
  // const handleSave = async () => {
  //   try {
  //     let response: any;
  //     let data = {
  //       token,
  //       title,
  //     };

  //     if (token) {
  //       response = await UpdateStakemap(data);
  //     } else {
  //       response = await CreateStakemap(data);
  //       navigate(`/${response.data.token}`);
  //     }

  //     if (response?.data) {
  //       updateUserContext({
  //         ...userContext,
  //         isAlert: true,
  //         alertMessage: response?.message,
  //         alertType: AlertType.Success,
  //       });
  //     }

  //     return response?.data?.token || token;
  //   } catch (error: any) {
  //     updateUserContext({
  //       ...userContext,
  //       isAlert: true,
  //       alertMessage: error.message,
  //       alertType: AlertType.Error,
  //     });
  //     return null;
  //   }
  // };

  const handleSave = async () => {
    try {
      let response: any;
      let data = { token, title, createdby: userContext?.userId };
      // if (!userContext?.userId) {
      //   navigate("/sign-up", { replace: true });
      //   return;
      // }
      if (token) {
        response = await UpdateStakemap(data);
      } else {
        response = await CreateStakemap(data);

        if (response?.data?.token) {
          localStorage.setItem("lt", response.data.token);
          updateUserContext((prev) => ({
            ...prev,
            localToken: response.data.token,
            token: response.data.token,
            UID: response.data.stakeMap?.UID,
          }));
          navigate(`/${response.data.token}`);
        } else {
          updateUserContext((prev) => ({
            ...prev,
            isAlert: true,
            alertMessage: response?.message,
            alertType: AlertType.Error,
          }));
        }
      }

      if (response?.data) {
        updateUserContext((prev) => ({
          ...prev,
          isAlert: true,
          alertMessage: response?.message,
          alertType: AlertType.Success,
        }));
      }

      return response?.data?.token || token;
    } catch (error: any) {
      updateUserContext((prev) => ({
        ...prev,
        isAlert: true,
        alertMessage: error.message,
        alertType: AlertType.Error,
      }));
      return null;
    }
  };

  const handleSubmit = async (formValues: any) => {
    setIsSubmitting(true);
    try {
      let currentToken = token;

      if (!currentToken) {
        currentToken = await handleSave();
        if (!currentToken) return;
      }

      const isUpdate = Number(methods.getValues("UID")) > 0;
      const payload: any = {
        token: currentToken,
        firstName: formValues.firstName,
        lastName: formValues.lastName,
        company: formValues.company,
        role: formValues.role,
        teamName: formValues.teamName,
        contact: formValues.contact,
        temperature: formValues.temperature,
        temperatureColourCode: formValues.temperatureColourCode,
        notes: formValues.notes,
        nodecolour: selectedColor || "#A7679B",
        UID: UID > 0 ? UID : undefined,
      };
      const response: any = isUpdate
        ? await UpdateStake(payload)
        : await CreateStake(payload);

      if (response?.data) {
        onClose("SUBMIT");
        const stakeholderUID = response.data.UID;
        // if (!isUpdate) {
        //   let fileToUpload = selectedImageFile;
        //   if (!fileToUpload) {
        //     const blob = await fetch(DefaultProfile).then((res) => res.blob());
        //     fileToUpload = new File([blob], `default-${Date.now()}.jpg`, {
        //       type: blob.type,
        //     });
        //   }
        //   await uploadProfileImage(fileToUpload, stakeholderUID);
        // }
        if (!isUpdate) {
          // ALWAYS upload default image
          const blob = await fetch(DefaultProfile).then((res) => res.blob());

          const fileToUpload = new File([blob], `default-${Date.now()}.jpg`, {
            type: blob.type,
          });

          await uploadProfileImage(fileToUpload, stakeholderUID,"CREATE");
        }

        if (!isUpdate && (formValues.notes?.trim() || formValues.temperature)) {
          const notePayload = {
            stakeUid: stakeholderUID,
            notesText: formValues.notes,
            notesDate: new Date().toISOString(),
            temperature: formValues.temperature,
          };

          const noteResponse: any = await CreateNote(notePayload);
          if (!noteResponse?.data) {
            throw new Error("Failed to save note");
          }
        }
        methods.reset({ ...initStackHolder });
        setShowMoreDetails(false);
        updateUserContext((prev) => ({
          ...prev,
          isAlert: true,
          alertMessage: response.message,
          alertType: AlertType.Success,
        }));
      }
    } catch (error: any) {
      updateUserContext((prev) => ({
        ...prev,
        isAlert: true,
        alertMessage: error.message,
        alertType: AlertType.Error,
      }));
    } finally {
      setIsSubmitting(false);
    }
  };

  const getStakeDetail = async (UID: number) => {
    let result: any;
    try {
      const response: any = await GetStakeDetail({ UID });
      if (response?.data?.data) {
        result = response.data.data;

        methods.reset(
          {
            ...initStackHolder,
            UID: parseInt(result.UID),
            firstName: result.FIRST_NAME || "",
            lastName: result.LAST_NAME || "",
            company: result.ORG_NAME || "",
            role: result.ROLE_NAME || "",
            teamName: result.TEAM_NAME || "",
            contact: result.CONTACT_DETAIL || "",
            temperature: result.TEMPERATURE_TYPE || "",
            nodecolour: result.COLOUR_HASH_CODE || "",
            notes: result.INITIAL_NOTE || "",
            profileImage: result.PROFILE_IMAGE_BASE64 || "",
          },
          {
            keepErrors: true,
          }
        );
        setSelectedColor(result.COLOUR_HASH_CODE || "");
        setSelectedImage(result.PROFILE_IMAGE_BASE64 || "");
      }

      return result;
    } catch (error) {
      console.error("Error fetching stakeholder detail:", error);
    }
  };

  const getColourList = async () => {
    try {
      let params = new URLSearchParams();
      const response: any = await GetColourList(params);

      if (response?.data) {
        const fetchedColors = response.data;
        setColorOptions(fetchedColors);
      } else {
        console.error("Invalid response:", response.data);
      }
    } catch (error: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error.message,
        alertType: AlertType.Error,
      });
    }
  };
  const fetchTemperatureTypeList = async () => {
    try {
      let params = new URLSearchParams();
      const response: any = await GetTempTypeList(params);

      if (response?.data) {
        setTemperatureTypeColl(response?.data);
        return response?.data;
      }
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };

  // Regex for detecting URLs/domains and emails
  const urlRegex = /((https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?)/gi;
  const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;

  // Function to parse text and return clickable links
  const parseLinks = (text?: string | null) => {
    if (!text) return null;

    const parts: React.ReactNode[] = [];
    let lastIndex = 0;

    const combinedRegex = new RegExp(
      `${urlRegex.source}|${emailRegex.source}`,
      "gi"
    );

    let match;
    while ((match = combinedRegex.exec(text)) !== null) {
      const { index } = match;
      if (index > lastIndex) {
        parts.push(text.slice(lastIndex, index));
      }

      const matchedText = match[0];

      // Simple check instead of .test() with global regex
      const isEmail = matchedText.includes("@");

      if (isEmail) {
        parts.push(
          <a
            key={index}
            href={`mailto:${matchedText}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1976d2", textDecoration: "underline" }}
          >
            {matchedText}
          </a>
        );
      } else {
        const url = matchedText.startsWith("http")
          ? matchedText
          : `https://${matchedText}`;
        parts.push(
          <a
            key={index}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1976d2", textDecoration: "underline" }}
          >
            {matchedText}
          </a>
        );
      }

      lastIndex = index + matchedText.length;
    }

    if (lastIndex < text.length) {
      parts.push(text.slice(lastIndex));
    }

    return parts;
  };

  useEffect(() => {
    if (UID > 0) {
      getStakeDetail(UID);
    } else {
      methods.reset(initStackHolder);
      setSelectedImage(DefaultProfile);
      setSelectedColor("");
    }
    getColourList();
    fetchTemperatureTypeList();
  }, [UID]);
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          padding: "30px",
          margin: 0,
          maxWidth: "738px",
          width: "auto",
        },
      }}
    >
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)}>
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              padding: "0px  0px  16px 0px ",
            }}
            className="label-item"
          >
            <Avatar sx={{ mr: 2 }}>
              <img
                src={editProfileIcon}
                alt="Edit profile"
                style={{ width: "42px", height: "42px" }}
              />
            </Avatar>
            <Typography className="edit-popup-title">
              {UID > 0 ? "Edit" : "Add new"} stakeholder
            </Typography>
            {/* {UID > 0 && (
              <Box sx={{ textAlign: "center", flex: 1, fontSize: "14px" }}>
                Map Title:
                <TextField
                  className="stake-edit-title"
                  value={title}
                  disabled={userContext?.userId != userContext?.stakemapUserId}
                  // onChange={(e) => setTitle(e.target.value)}
                  // onKeyDown={handleKeyDown}
                  // onBlur={handleBlur}
                  placeholder="Untitled Stake"
                  variant="standard"
                />
              </Box>
            )} */}
            <IconButton
              onClick={handleClose}
              sx={{
                ml: "auto",
                padding: "0 !important",
                backgroundColor: "transparent !important",
                "&:hover": {
                  backgroundColor: "transparent !important",
                },
              }}
            >
              <img
                src={CloseIcon}
                alt="Close"
                style={{ width: 18, height: 19 }}
              />
            </IconButton>
          </DialogTitle>

          <DialogContent
            dividers
            sx={{
              px: 3,
              py: 2,
              padding: "16px 0px 0px 0px",
              borderBottom: "none",
            }}
          >
            {/* Picture */}
            {Number(methods.getValues("UID")) > 0 && (
              <Box sx={{ display: "flex", alignItems: "center", pb: 1 }}>
                <Typography
                  sx={{
                    width: "123px",
                    textAlign: "left",
                    paddingRight: "12px",
                  }}
                  className="label-item-add-stake"
                >
                  Picture
                </Typography>
                <Box display="flex" alignItems="center" width={"540px"}>
                  <Box sx={{ position: "relative", display: "inline-block" }}>
                    <Avatar
                      // src={methods.getValues("profileImage") || selectedImage}
                      src={
                        selectedImage && selectedImage.trim() !== ""
                          ? selectedImage
                          : methods.watch("profileImage") || undefined
                      }
                      sx={{ width: 130, height: 130 }}
                    />
                    <IconButton
                      sx={{
                        p: 0,
                        position: "absolute",
                        borderRadius: 0,
                        minWidth: "auto",
                        bottom: 0,
                        right: 0,
                        width: 32,
                        height: 32,
                      }}
                      onClick={() => fileInputRef.current?.click()}
                    >
                      <img
                        src={UploadProfileEdit}
                        alt="Edit profile"
                        style={{ width: "32px", height: "32px" }}
                      />
                    </IconButton>
                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      marginRight: "4px",
                      marginLeft: "4px",
                    }}
                  >
                    <Box
                      sx={{
                        flex: 1,
                        height: "1px",
                        backgroundColor: "#E9E9E9",
                      }}
                    />
                    <Typography
                      sx={{ mx: 0.5 }}
                      className="label-item-add-stake-input"
                    >
                      or
                    </Typography>
                    <Box
                      sx={{
                        flex: 1,
                        height: "1px",
                        backgroundColor: "#E9E9E9",
                      }}
                    />
                  </Box>

                  <Box sx={{ height: "130px" }}>
                    <Typography
                      fontWeight="100"
                      sx={{ mb: 0.5 }}
                      className="item-avatar"
                    >
                      {/* Select default Picture */}
                      Select default profile image
                    </Typography>

                    <Box display="flex" gap={2} sx={{ height: "106px" }}>
                      {defaultImages.map((img, idx) => (
                        <Box
                          key={idx}
                          onClick={() => {
                            handleImageSelect(img);
                            methods.setValue("profileImage", img);
                          }}
                          sx={{
                            width: 92,
                            height: 92,
                            borderRadius: "50%",
                            border: "2px solid gray",
                            overflow: "hidden",
                            cursor: "pointer",
                            transition: "0.2s",
                            "&:hover": { borderColor: "#7B2D26" },
                          }}
                        >
                          <img
                            src={img}
                            alt={`Default ${idx}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
            {/* First Name */}
            <Box display="flex" alignItems="flex-start" sx={{ mb: 1 }}>
              <FormLabel
                sx={{
                  width: "123px",
                  textAlign: "left",
                  paddingRight: "12px",
                  paddingTop: "14px",
                }}
                className={`label-item-add-stake ${
                  methods.formState.errors.firstName ? "validation-message" : ""
                }`}
              >
                * First name
              </FormLabel>
              <Box sx={{ flexGrow: 1 }}>
                <Controller
                  name="firstName"
                  control={methods.control}
                  defaultValue=""
                  render={({ field }) => {
                    const currentLength = field.value?.length || 0;
                    const maxLength = 90;
                    return (
                      <Box sx={{ width: "540px" }}>
                        <TextField
                          {...field}
                          fullWidth
                          placeholder="John"
                          // variant="outlined"
                          multiline={false}
                          error={!!methods.formState.errors.firstName}
                          // helperText={methods.formState.errors.firstName?.message}
                          helperText={
                            methods.formState.errors.firstName?.message || ""
                          }
                          InputProps={{
                            className: "label-item-add-stake-input",
                            style: {
                              fontSize: "16px",
                              height: "52px",
                              width: "540px",
                              backgroundColor: "white",
                              // paddingLeft: "16px",
                              // paddingRight: "16px",
                            },
                          }}
                          inputProps={{
                            maxLength: 90,
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              padding: 0,
                            },
                            "& .MuiInputBase-inputMultiline": {
                              padding: 0,
                              lineHeight: 1.2,
                              minHeight: "unset",
                            },
                            "& .MuiFormHelperText-root": {
                              marginLeft: 0,
                              marginRight: 0,
                            },
                          }}
                        />
                        {!methods.formState.errors.firstName && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              mt: 0.5,
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{ color: "gray" }}
                            >
                              ({currentLength}/{maxLength})
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    );
                  }}
                />
              </Box>
            </Box>

            {/* Last Name */}
            <Box display="flex" alignItems="flex-start" sx={{ mb: 1 }}>
              <FormLabel
                sx={{
                  width: "123px",
                  textAlign: "left",
                  paddingRight: "12px",
                  paddingTop: "14px",
                }}
                className={`label-item-add-stake ${
                  methods.formState.errors.lastName ? "validation-message" : ""
                }`}
              >
                Last name
              </FormLabel>
              <Box sx={{ flexGrow: 1 }}>
                <Controller
                  name="lastName"
                  control={methods.control}
                  defaultValue=""
                  render={({ field }) => {
                    const currentLength = field.value?.length || 0;
                    const maxLength = 90;
                    return (
                      <Box sx={{ width: "540px" }}>
                        <TextField
                          {...field}
                          fullWidth
                          placeholder="Doe"
                          // variant="outlined"
                          multiline={false}
                          error={!!methods.formState.errors.lastName}
                          helperText={
                            methods.formState.errors.lastName?.message || ""
                          }
                          InputProps={{
                            className: "label-item-add-stake-input",
                            style: {
                              fontSize: "16px",
                              height: "52px",
                              width: "540px",
                              backgroundColor: "white",
                              // paddingLeft: "16px",
                              // paddingRight: "16px",
                            },
                          }}
                          inputProps={{
                            maxLength: 90,
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              padding: 0,
                            },
                            "& .MuiInputBase-inputMultiline": {
                              padding: 0,
                              lineHeight: 1.2,
                              minHeight: "unset",
                            },
                          }}
                        />
                        {!methods.formState.errors.lastName && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              mt: 0.5,
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{ color: "gray" }}
                            >
                              ({currentLength}/{maxLength})
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    );
                  }}
                />
              </Box>
            </Box>

            {/* Company */}
            <Box display="flex" alignItems="flex-start" sx={{ mb: 1 }}>
              <FormLabel
                sx={{
                  width: "123px",
                  textAlign: "left",
                  paddingRight: "12px",
                  paddingTop: "14px",
                }}
                className={`label-item-add-stake ${
                  methods.formState.errors.company ? "validation-message" : ""
                }`}
              >
                * Company
              </FormLabel>

              <Box sx={{ flexGrow: 1 }}>
                <Controller
                  name="company"
                  control={methods.control}
                  defaultValue=""
                  render={({ field }) => {
                    const currentLength = field.value?.length || 0;
                    const maxLength = 90;
                    return (
                      <Box sx={{ width: "540px" }}>
                        <TextField
                          {...field}
                          fullWidth
                          placeholder="A&X marketing Consultants"
                          // variant="outlined"
                          multiline={false}
                          error={!!methods.formState.errors.company}
                          helperText={
                            methods.formState.errors.company?.message || ""
                          }
                          InputProps={{
                            className: "label-item-add-stake-input",
                            style: {
                              fontSize: "16px",
                              height: "52px",
                              width: "540px",
                              backgroundColor: "white",
                              // paddingLeft: "16px",
                              // paddingRight: "16px",
                            },
                          }}
                          inputProps={{
                            maxLength: 90,
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              padding: 0,
                            },
                            "& .MuiInputBase-inputMultiline": {
                              padding: 0,
                              lineHeight: 1.2,
                              minHeight: "unset",
                            },
                            "& .MuiFormHelperText-root": {
                              marginLeft: 0,
                              marginRight: 0,
                            },
                          }}
                        />
                        {!methods.formState.errors.company && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              mt: 0.5,
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{ color: "gray" }}
                            >
                              ({currentLength}/{maxLength})
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    );
                  }}
                />
              </Box>
            </Box>

            {/* Add more details toggle */}
            {Number(methods.getValues("UID")) <= 0 && (
              <Box
                display="flex"
                justifyContent="flex-end"
                sx={{ mt: 1, mb: 1 }}
              >
                <Typography
                  sx={{
                    fontWeight: "400px !important",
                    // color: '#4C0808',
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onClick={handleToggleMoreDetails}
                >
                  {showMoreDetails
                    ? "Hide details" + "\u00A0"
                    : "Add more details (Optional)" + "\u00A0"}

                  {showMoreDetails ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  )}
                </Typography>
              </Box>
            )}

            {/* More Details */}
            {(showMoreDetails || Number(methods.getValues("UID")) > 0) && (
              <>
                <Box display="flex" alignItems="flex-start" sx={{ mb: 1 }}>
                  <FormLabel
                    sx={{
                      width: "123px",
                      textAlign: "left",
                      paddingRight: "12px",
                      paddingTop: "14px",
                    }}
                    className={`label-item-add-stake ${
                      methods.formState.errors.role ? "validation-message" : ""
                    }`}
                  >
                    Role
                  </FormLabel>
                  <Box sx={{ flexGrow: 1 }}>
                    <Controller
                      name="role"
                      control={methods.control}
                      defaultValue=""
                      render={({ field }) => {
                        const currentLength = field.value?.length || 0;
                        const maxLength = 90;
                        return (
                          <Box sx={{ width: "540px" }}>
                            <TextField
                              {...field}
                              fullWidth
                              placeholder="Marketing Director"
                              multiline={false}
                              error={!!methods.formState.errors.role}
                              helperText={
                                methods.formState.errors.role?.message || ""
                              }
                              InputProps={{
                                className: "label-item-add-stake-input",
                                style: {
                                  fontSize: "16px",
                                  height: "52px",
                                  width: "540px",
                                  backgroundColor: "white",
                                  // paddingLeft: "16px",
                                  // paddingRight: "16px",
                                },
                              }}
                              inputProps={{
                                maxLength: 90,
                              }}
                              sx={{
                                "& .MuiInputBase-root": {
                                  padding: 0,
                                },
                                "& .MuiInputBase-inputMultiline": {
                                  padding: 0,
                                  lineHeight: 1.2,
                                  minHeight: "unset",
                                },
                              }}
                            />
                            {!methods.formState.errors.role && (
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  mt: 0.5,
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  sx={{ color: "gray" }}
                                >
                                  ({currentLength}/{maxLength})
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        );
                      }}
                    />
                  </Box>
                </Box>

                <Box display="flex" alignItems="flex-start" sx={{ mb: 1 }}>
                  <FormLabel
                    sx={{
                      width: "123px",
                      textAlign: "left",
                      paddingRight: "12px",
                    }}
                    className={`label-item-add-stake ${
                      methods.formState.errors.teamName
                        ? "validation-message"
                        : ""
                    }`}
                  >
                    Team/ Department
                  </FormLabel>
                  <Box sx={{ flexGrow: 1 }}>
                    <Controller
                      name="teamName"
                      control={methods.control}
                      defaultValue=""
                      render={({ field }) => {
                        const currentLength = field.value?.length || 0;
                        const maxLength = 90;
                        return (
                          <Box sx={{ width: "540px" }}>
                            <TextField
                              {...field}
                              fullWidth
                              placeholder="Marketing & Sales"
                              multiline={false}
                              error={!!methods.formState.errors.teamName}
                              helperText={
                                methods.formState.errors.teamName?.message || ""
                              }
                              InputProps={{
                                className: "label-item-add-stake-input",
                                style: {
                                  fontSize: "16px",
                                  height: "52px",
                                  width: "540px",
                                  backgroundColor: "white",
                                  // paddingLeft: "16px",
                                  // paddingRight: "16px",
                                },
                              }}
                              inputProps={{
                                maxLength: 90,
                              }}
                              sx={{
                                "& .MuiInputBase-root": {
                                  padding: 0,
                                },
                                "& .MuiInputBase-inputMultiline": {
                                  padding: 0,
                                  lineHeight: 1.2,
                                  minHeight: "unset",
                                },
                              }}
                            />
                            {!methods.formState.errors.teamName && (
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  mt: 0.5,
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  sx={{ color: "gray" }}
                                >
                                  ({currentLength}/{maxLength})
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        );
                      }}
                    />
                  </Box>
                </Box>

                <Box display="flex" alignItems="flex-start" sx={{ mb: 1 }}>
                  <FormLabel
                    sx={{
                      width: "123px",
                      textAlign: "left",
                      paddingRight: "12px",
                    }}
                    className={`label-item-add-stake ${
                      methods.formState.errors.contact
                        ? "validation-message"
                        : ""
                    }`}
                  >
                    Contact/ LinkedIn
                  </FormLabel>
                  <Box sx={{ flexGrow: 1 }}>
                    <Controller
                      name="contact"
                      control={methods.control}
                      defaultValue=""
                      render={({ field }) => {
                        const currentLength = field.value?.length || 0;
                        const maxLength = 500;
                        return (
                          <Box sx={{ width: "540px" }}>
                            <TextField
                              {...field}
                              fullWidth
                              placeholder="https://www.Linkedin.com/johndoe"
                              multiline={false}
                              error={!!methods.formState.errors.contact}
                              helperText={
                                methods.formState.errors.contact?.message || ""
                              }
                              InputProps={{
                                className: "label-item-add-stake-input",
                                style: {
                                  fontSize: "16px",
                                  height: "52px",
                                  width: "540px",
                                  backgroundColor: "white",
                                  // paddingLeft: "16px",
                                  // paddingRight: "16px",
                                },
                              }}
                              inputProps={{
                                maxLength: 500,
                              }}
                              sx={{
                                "& .MuiInputBase-root": {
                                  padding: 0,
                                },
                                "& .MuiInputBase-inputMultiline": {
                                  padding: 0,
                                  lineHeight: 1.2,
                                  minHeight: "unset",
                                },
                              }}
                            />
                            {!methods.formState.errors.contact && (
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  mt: 0.5,
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  sx={{ color: "gray" }}
                                >
                                  ({currentLength}/{maxLength})
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        );
                      }}
                    />
                  </Box>
                </Box>

                {Number(methods.getValues("UID")) > 0 && (
                  <Box display="flex" alignItems="flex-start" sx={{ mb: 1 }}>
                    <FormLabel
                      sx={{
                        width: "125px",
                        textAlign: "left",
                        paddingRight: "12px",
                        paddingTop: "9px",
                      }}
                      className={`label-item-add-stake ${
                        methods.formState.errors.nodecolour
                          ? "validation-message"
                          : ""
                      }`}
                    >
                      * Node Colour
                    </FormLabel>

                    <Box sx={{ flexGrow: 1 }}>
                      <Box
                        gap={1}
                        mb={0.5}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          height: "52px",
                          paddingRight: "2px",
                        }}
                      >
                        <Box
                          onClick={handleCustomColorClick}
                          sx={{
                            width: 40,
                            height: 40,
                            borderRadius: "4px",
                            cursor: "pointer",
                            background:
                              "conic-gradient(red, orange, yellow, green, cyan, blue, violet, red)",
                            p: "2px",
                          }}
                        >
                          <Box
                            sx={{
                              flex: 1,
                              height: "100%",
                              borderRadius: "2px",
                              backgroundColor: "#fff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#555",
                            }}
                          >
                            {"+"}
                          </Box>
                        </Box>
                        <Box
                          onClick={() => {
                            setSelectedColor("transparent");
                            methods.setValue("nodecolour", "transparent", {
                              shouldValidate: true,
                            });
                          }}
                          sx={{
                            width: 40,
                            height: 40,
                            borderRadius: "2px",
                            cursor: "pointer",
                          }}
                        >
                          <img
                            src={nodeIcon}
                            style={{ width: 40, height: 40 }}
                          />
                        </Box>
                        {colorOptions?.map((color, idx) => (
                          <Box
                            key={idx}
                            onClick={() => {
                              setSelectedColor(color);
                              methods.setValue("nodecolour", color, {
                                shouldValidate: true,
                              });
                            }}
                            sx={{
                              width: 40,
                              height: 40,
                              borderRadius: "4px",
                              backgroundColor: color,
                              cursor: "pointer",
                              outline:
                                selectedColor === color
                                  ? "3px solid #4e0000"
                                  : " ",
                              transition: "opacity 0.2s",
                              "&:hover": { opacity: 0.8 },
                            }}
                          />
                        ))}
                      </Box>
                      {/* Popover with color picker */}
                      <Popover
                        open={openColorPicker}
                        anchorEl={anchorEl}
                        onClose={handleClosePicker}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                      >
                        <SketchPicker
                          color={selectedColor}
                          onChange={(color: any) => {
                            setSelectedColor(color.hex);
                            methods.setValue("nodecolour", color.hex, {
                              shouldValidate: true,
                            });

                            // // Optionally push into DB colors list
                            // if (!colorOptions.includes(color.hex)) {
                            //   setColorOptions((prev) => [...prev, color.hex]);
                            // }
                          }}
                        />
                      </Popover>
                      {methods.formState.errors.nodecolour && (
                        <Typography
                          className="validation-message"
                          sx={{ fontSize: "13px" }}
                        >
                          {methods.formState.errors.nodecolour.message}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                )}

                {Number(methods.getValues("UID")) <= 0 && (
                  <>
                    <Box display="flex" alignItems="flex-start" sx={{ mb: 1 }}>
                      <FormLabel
                        sx={{
                          width: "123px",
                          textAlign: "left",
                          paddingRight: "12px",
                        }}
                        className={`label-item-add-stake ${
                          methods.formState.errors.temperature
                            ? "validation-message"
                            : ""
                        }`}
                      >
                        {/* Current Temperature */}
                        Current Status
                      </FormLabel>

                      <Box sx={{ flexGrow: 1 }}>
                        <Controller
                          name="temperature"
                          control={methods.control}
                          render={({ field }) => {
                            const selectedOption = temperatureTypeColl.find(
                              (option) => option.value === field.value
                            );
                            return (
                              <Select
                                options={temperatureTypeColl}
                                value={selectedOption}
                                // onChange={(option) =>
                                //   field.onChange(option?.value || "")
                                // }
                                onChange={(option) => {
                                  field.onChange(option?.value || "");
                                  methods.setValue(
                                    "temperatureColourCode",
                                    option?.COLOUR_HASH_CODE || ""
                                  );
                                }}
                                menuPortalTarget={document.body}
                                isClearable
                                isSearchable
                                placeholder="Select Status"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    height: "52px",
                                    width: "540px",
                                    backgroundColor:
                                      selectedOption?.COLOUR_HASH_CODE ||
                                      "white",
                                    borderColor: "rgba(0, 0, 0, 0.23)",
                                    "&:hover": {
                                      borderColor: "rgba(0, 0, 0, 0.87)",
                                    },
                                    boxShadow: "none",
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: 0,
                                    padding: 0,
                                    fontWeight: 400,
                                    fontSize: "14px",
                                  }),
                                  option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isSelected
                                      ? state.data.COLOUR_HASH_CODE
                                      : state.isFocused
                                      ? "#eee"
                                      : "white",
                                    color: "#000",
                                  }),
                                }}
                              />
                            );
                          }}
                          // render={({ field }) => (
                          //   <Select
                          //     {...field}
                          //     options={temperatureTypeColl}
                          //     menuPortalTarget={document.body}
                          //     value={
                          //       temperatureTypeColl.find(
                          //         (option) => option.value === field.value
                          //       ) || null
                          //     }
                          //     onChange={(selectedOption) =>
                          //       field.onChange(selectedOption?.value || "")
                          //     }
                          //     isClearable
                          //     isSearchable
                          //     placeholder="Select Temperature"
                          //     styles={{
                          //       control: (base) => ({
                          //         ...base,
                          //         height: "52px",
                          //         width: "540px",
                          //         backgroundColor: "white",
                          //         borderColor: "rgba(0, 0, 0, 0.23)",
                          //         "&:hover": {
                          //           borderColor: "rgba(0, 0, 0, 0.87)",
                          //         },
                          //         boxShadow: "none",
                          //       }),
                          //       valueContainer: (base) => ({
                          //         ...base,
                          //         padding: "2px 8px",
                          //       }),
                          //       input: (base) => ({
                          //         ...base,
                          //         margin: 0,
                          //         padding: 0,
                          //         fontWeight: 400,
                          //         fontSize: "14px",
                          //         color: "#232323",
                          //       }),
                          //       menuPortal: (base) => ({
                          //         ...base,
                          //         zIndex: 9999,
                          //       }),
                          //     }}
                          //   />
                          // )}
                        />
                        {methods.formState.errors.temperature && (
                          <Typography
                            className="validation-message"
                            sx={{ fontSize: "13px", mt: "4px" }}
                          >
                            {methods.formState.errors.temperature.message}
                          </Typography>
                        )}
                      </Box>
                    </Box>

                    <Box
                      display="flex"
                      alignItems="flex-start"
                      sx={{ mb: 1, pt: 0 }}
                    >
                      <FormLabel
                        sx={{
                          width: "123px",
                          textAlign: "left",
                          paddingRight: "12px",
                          paddingTop: "14px",
                        }}
                        className={`label-item-add-stake ${
                          methods.formState.errors.notes
                            ? "validation-message"
                            : ""
                        }`}
                      >
                        Initial Notes
                      </FormLabel>
                      <Box sx={{ flexGrow: 1 }}>
                        <Controller
                          name="notes"
                          control={methods.control}
                          defaultValue=""
                          render={({ field }) => {
                            const currentLength = field.value?.length || 0;
                            const maxLength = 5000;
                            return (
                              <Box sx={{ width: "540px" }}>
                                <TextField
                                  {...field}
                                  fullWidth
                                  multiline
                                  placeholder="Initial Notes"
                                  error={!!methods.formState.errors.notes}
                                  helperText={
                                    methods.formState.errors.notes?.message ||
                                    ""
                                  }
                                  inputProps={{
                                    maxLength: 5000,
                                  }}
                                  sx={{
                                    "& textarea": {
                                      height: "150px !important",
                                      maxHeight: "150px !important",
                                      overflowY: "auto !important",
                                      boxSizing: "border-box",
                                      resize: "none",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                      alignItems: "flex-start",
                                    },
                                  }}
                                />
                                {/* Counter only when no error */}
                                {!methods.formState.errors.notes && (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      mt: 0.5,
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      sx={{ color: "gray" }}
                                    >
                                      ({currentLength}/{maxLength})
                                    </Typography>
                                  </Box>
                                )}
                              </Box>
                            );
                          }}
                        />
                      </Box>
                    </Box>
                  </>
                )}
              </>
            )}
          </DialogContent>

          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              padding: 0,
              width: "100%",
              height: "42px",
              paddingTop: "30px",
            }}
          >
            <Button
              onClick={handleClose}
              variant="outlined"
              sx={{
                textTransform: "none",
                fontWeight: 400,
                borderRadius: "4px",
                borderColor: "#4C0808",
                color: "#4C0808",
                // marginRight: "28px",
                marginRight: "0px",
                width: "98px",
                height: "42px",
                backgroundColor: "#ffffff",
              }}
            >
              Cancel
            </Button>
            <Button
              // onClick={handleSubmit}
              onClick={methods.handleSubmit(handleSubmit)}
              disabled={isSubmitting}
              variant="contained"
              sx={{
                boxShadow: "none",
                textTransform: "none",
                fontWeight: 400,
                borderRadius: "4px",
                width: "98px",
                height: "42px",
                backgroundColor: "#4C0808",
                "&:hover": {
                  backgroundColor: "#4e0000",
                  boxShadow: "none",
                },
              }}
            >
              Save
            </Button>
          </DialogActions>

          {Number(methods.getValues("UID")) > 0 && (
            <Typography
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                paddingBottom: "10px",
                paddingTop: "50px",
                color: "rgba(145, 145, 145, 1)",
              }}
            >
              Looking for Temperature and Notes?{" "}
              <Box
                component="span"
                sx={{
                  color: "#4C0808",
                  ml: 0.5,
                  cursor: "pointer",
                  textDecoration: "none",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
                // onClick={() => openNotesPopup(UID)}
                onClick={() => onClose("OPEN_NOTES", UID)}
              >
                Go to “Add notes”
              </Box>
            </Typography>
          )}
        </form>
      </FormProvider>

      <AddNoteDialog
        UID={0}
        STAKEUID={addNotesPopup?.UID || ""}
        open={addNotesPopup.open}
        onClose={closeNotesPopup}
      />
    </Dialog>
  );
};

export default AddStakeHolderDialog;
